import { useCallback, useState } from 'react'
import type { WorldPoint } from '@/analysis/apiTypes'

export interface HoverState {
  p: WorldPoint
  x: number
  y: number
}

export function useHover() {
  const [hover, setHover] = useState<HoverState | null>(null)

  const onEnter = useCallback((p: WorldPoint, x: number, y: number) => {
    setHover({ p, x, y })
  }, [])

  // Only clear hover if we're still showing the same point — guards against
  // race conditions when the cursor moves between adjacent markers.
  const onLeave = useCallback((p: WorldPoint) => {
    setHover((h) => (h?.p?.id === p.id ? null : h))
  }, [])

  return { hover, onEnter, onLeave }
}
